/**
 * セール文言を省略形の表示にするかどうかの閾値
 *
 * 【背景】
 * PAY-3007 にて、横幅に応じて、セール文言を
 * フルテキストで表示する場合、と
 * 省略形で表示する場合、に切り替える必要性が生じた。
 *
 * そのため、下記のように修正している。
 * @see https://celsys.backlog.jp/view/PAY-3007#comment-241067207
 *
 * 【重要】
 * ここで設定している数値は、セール用文言を一行で表示したときに横幅が親要素からはみ出ないサイズで指定している。
 * そのため、文言が変更された場合、この値も適切な値に変更する必要がある。（変更しないと親要素からはみ出る可能性がある）
 *
 * */
export const ABBREVIATION_THRESHOLD_WIDTH = 800;
